import { useState } from 'react'

interface AccordionState {
  expanded: boolean
  openAccordion: () => void
  toggleAccordion: () => void
  closeAccordion: () => void
}

export default function useAccordion(defaultExpanded = false): AccordionState {
  const [expanded, setExpanded] = useState<boolean>(defaultExpanded)

  const openAccordion = () => {
    setExpanded(true)
  }

  const toggleAccordion = () => {
    setExpanded(!expanded)
  }

  const closeAccordion = () => {
    setExpanded(false)
  }

  return { expanded, openAccordion, toggleAccordion, closeAccordion }
}
